var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25435 7.25435C9.59349 6.91522 10.1433 6.91522 10.4825 7.25435L15.1141 11.8859C15.4532 12.2251 15.4532 12.7749 15.1141 13.1141L10.4825 17.7456C10.1433 18.0848 9.59349 18.0848 9.25435 17.7456C8.91522 17.4065 8.91522 16.8567 9.25435 16.5175L13.2719 12.5L9.25435 8.48249C8.91522 8.14335 8.91522 7.59349 9.25435 7.25435Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.b79fbd7250f1316a6648044d0fcf2d20.svg";
export { ForwardRef as ReactComponent };